import { render, staticRenderFns } from "./unsubscribeBlock.vue?vue&type=template&id=524d143b&"
import script from "./unsubscribeBlock.vue?vue&type=script&lang=js&"
export * from "./unsubscribeBlock.vue?vue&type=script&lang=js&"
import style0 from "./unsubscribeBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports